import {
  AppBar,
  Dialog,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import SignUpForm from "./SignUpForm";
import SignInForm from "./SignInForm";
import { useSelector } from "react-redux";
import { colors, fonts } from "../../theme/designTokens";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AuthDialogue({
  signUpOpen,
  setSignUpOpen,
  signInOpen,
  setSignInOpen,
  setLoginStatus,
}) {
  // Functions
  const handleDialogueClose = () => {
    setSignUpOpen(false);
    setSignInOpen(false);
  };

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate
  return (
    <Dialog
      fullScreen
      open={signUpOpen || signInOpen}
      onClose={handleDialogueClose}
      TransitionComponent={Transition}
      PaperProps={{ sx: { bgcolor: colors.paperTint } }}
    >
      <AppBar
        sx={{
          position: "relative",
          bgcolor: colors.paper,
          boxShadow: "none",
          borderBottom: `1px solid ${colors.line}`,
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            onClick={handleDialogueClose}
            aria-label="close"
            sx={{ color: colors.ink2 }}
          >
            <CloseIcon />
          </IconButton>
          <Typography
            sx={{
              ml: 2,
              flex: 1,
              fontFamily: fonts.display,
              fontWeight: 800,
              color: colors.ink,
            }}
            variant="h6"
            component="div"
          >
            {signUpOpen && translateFront("Sign up")}
            {signInOpen && translateFront("Sign In")}
          </Typography>
        </Toolbar>
      </AppBar>
      {signUpOpen && (
        <SignUpForm
          setLoginStatus={setLoginStatus}
          setSignUpOpen={setSignUpOpen}
          setSignInOpen={setSignInOpen}
        />
      )}
      {signInOpen && (
        <SignInForm
          setLoginStatus={setLoginStatus}
          setSignUpOpen={setSignUpOpen}
          setSignInOpen={setSignInOpen}
        />
      )}
    </Dialog>
  );
}
